import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/app/App.tsx");
